import { useFeatureFlag } from 'shared/hooks/feature-flag';
import { FeatureFlag } from 'shared/models/feature-flag';

import { FeatureSubscriptionType } from 'features/feature-subscriptions/models/feature-subscription-type';

export type FeatureSubscriptionFeatureFlag = {
  isFeatureFlagForSubscriptionEnabled: (type: FeatureSubscriptionType) => boolean;
  isCareConnectEnabled: boolean;
};

const useFeatureSubscriptionFeatureFlag = (): FeatureSubscriptionFeatureFlag => {
  const { isEnabled: isCareConnectEnabled } = useFeatureFlag(FeatureFlag.CARE_CONNECT);

  const subscriptionTypeToFeatureFlagMap: Record<FeatureSubscriptionType, boolean> = {
    [FeatureSubscriptionType.CareConnect]: isCareConnectEnabled,
  };

  const isFeatureFlagForSubscriptionEnabled = (type: FeatureSubscriptionType): boolean => subscriptionTypeToFeatureFlagMap[type] ?? false;

  return { isFeatureFlagForSubscriptionEnabled, isCareConnectEnabled };
};

export default useFeatureSubscriptionFeatureFlag;
